(() => {
  const initialiseMobileMenuSearch = (scope = document) => {
    scope.querySelectorAll('#navigation-mobile.custom-mobile-menu').forEach((drawer) => {
      if (drawer.dataset.moonSearchReady === 'true') return;

      const openButton = drawer.querySelector('[data-moon-menu-search-open]');
      const panel = drawer.querySelector('#MoonMobileMenuSearch');
      const scrim = drawer.querySelector('.moon-mobile-menu__search-scrim');
      const input = drawer.querySelector('[data-moon-menu-search-input]');
      const clearButton = drawer.querySelector('[data-moon-menu-search-clear]');
      const closeButtons = drawer.querySelectorAll('[data-moon-menu-search-close]');

      if (!openButton || !panel || !scrim || !input) return;

      const closeSearch = () => {
        panel.hidden = true;
        scrim.hidden = true;
        drawer.classList.remove('is-search-open');
        openButton.setAttribute('aria-expanded', 'false');
      };

      const openSearch = () => {
        panel.hidden = false;
        scrim.hidden = false;
        drawer.classList.add('is-search-open');
        openButton.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => input.focus());
      };

      openButton.addEventListener('click', openSearch);
      closeButtons.forEach((button) => button.addEventListener('click', closeSearch));

      clearButton?.addEventListener('click', () => {
        input.value = '';
        input.focus();
      });

      drawer.querySelectorAll('[data-menu-close-sidebar]').forEach((button) => {
        button.addEventListener('click', closeSearch);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-search-open')) {
          closeSearch();
          openButton.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (event.target.closest('.background-overlay')) closeSearch();
      });

      drawer.dataset.moonSearchReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseMobileMenuSearch());
  } else {
    initialiseMobileMenuSearch();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseMobileMenuSearch(event.target));
})();
